import { defineComponent as _defineComponent } from 'vue'
import { toRef, computed, ref } from 'vue';
import { useSwiper, ManagedSwiper, SwiperNavigationButton, SwiperPagination } from '@/ui/shared/swiper';
import { useStandardLoadManager, SlideRenderState } from '@/ui/shared/swiper/lazyload';
import { Zoom } from 'swiper/modules';

import AutoOptimizedImage from '@/ui/shared/image/auto-optimized-image/AutoOptimizedImage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PDPSwiperMobile',
  props: {
    images: { default: () => [] },
    altTextOverride: { default: undefined }
  },
  setup(__props: any) {

const props = __props as { images: CarouselImageViewObject[], altTextOverride: string }



const zoomed = ref(false);

const { swiperManager } = useSwiper<CarouselImageViewObject>({
    slides: toRef(props, 'images'),
    swiperOptions: {
        direction: 'horizontal',
        loop: true,
        preventInteractionOnTransition: true,
        touchStartForcePreventDefault: true,
        zoom: {
            maxRatio: 5,
            minRatio: 1
        },
        modules: [Zoom],
        on: {
            zoomChange: (_swiper, zoomLevel) => {
                zoomed.value = zoomLevel > 0;
            }
        }
    }
});

const { getSlideRenderStatus } = useStandardLoadManager(swiperManager);

const slideStatuses = computed(() => {
    return swiperManager.slides.value.map((_, index) => getSlideRenderStatus(index));
});


return { __sfc: true,props, zoomed, swiperManager, getSlideRenderStatus, slideStatuses, ManagedSwiper, SwiperNavigationButton, SwiperPagination, SlideRenderState, AutoOptimizedImage }
}

})